export default __webpack_public_path__ + "static/media/bananas.68a1cbe8.webp";